import React from 'react';
import ReactDOM from 'react-dom';
import App from './App';
import { Provider } from 'react-redux';
import { Switch, BrowserRouter } from 'react-router-dom';
import { Auth0Provider } from '@auth0/auth0-react';
import { UserbackProvider } from '@userback/react';
import { LocalizationProvider } from '@mui/x-date-pickers';
import { AdapterMoment } from '@mui/x-date-pickers/AdapterMoment';
import { store } from './store';

// eslint-disable-next-line no-console
console.info(`Commit hash: ${process.env.REACT_APP_GIT_COMMIT_HASH}`);

ReactDOM.render(
  <UserbackProvider token="38387|75892|LKXfvMo68546bkaAVD6aKvKlC">
    <Provider store={store}>
      <BrowserRouter>
        <Auth0Provider
          domain={process.env.REACT_APP_AUTH0_DOMAIN}
          clientId={process.env.REACT_APP_AUTH0_CLIENTID}
          redirectUri={process.env.REACT_APP_LOGIN_REDIRECT}
          audience={process.env.REACT_APP_AUTH0_AUDIENCE}
          cacheLocation={
            process.env.REACT_APP_ENVIRONMENT_NAME === 'cypress'
              ? 'localstorage'
              : undefined
          }
        >
          <Switch>
            <LocalizationProvider dateAdapter={AdapterMoment}>
              <App />
            </LocalizationProvider>
          </Switch>
        </Auth0Provider>
      </BrowserRouter>
    </Provider>
  </UserbackProvider>,
  document.getElementById('root')
);
